import styled from "styled-components";
import { Typography } from "@mui/material";
import { theme } from "../../utils/globalStyles/colors";

export const Container = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 16px 16px 0; /* o espaço do menu inferior fica no BodyContainer */
  box-sizing: border-box; /* ISSO RESOLVE O VAZAMENTO DA TELA! */
  display: flex;
  flex-direction: column;
`;

export const Label = styled(Typography)`
  font-weight: 800 !important;
  color: ${theme.colors.base};
  font-size: 1.3rem !important;
  padding: 0 4px;
`;

/* Chips de categoria "grudados" no topo enquanto a lista rola */
export const FilterBar = styled.div`
  position: sticky;
  top: 0;
  z-index: 5;
  background-color: #f7f9fc; /* mesma cor do fundo da tela */
  padding: 12px 0;
  margin-bottom: 4px;
`;

export const Count = styled.span<{ $active: boolean }>`
  font-size: 11px;
  font-weight: 800;
  min-width: 18px;
  padding: 1px 6px;
  border-radius: 999px;
  box-sizing: border-box;
  text-align: center;
  background-color: ${({ $active }) =>
    $active ? "rgba(255, 255, 255, 0.25)" : "rgba(0, 0, 0, 0.06)"};
`;
